import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TableColumnsConfigHelper } from '@app/core/models/configuration/table-columns-config-helper';
import { TableColumnsConfigKey } from '@app/core/models/configuration/table-columns-config-key.model';
import { ImportDetailModel } from '@app/core/models/imports/import-detail.model';
import { ImportModel } from '@app/core/models/imports/import.model';
import { ImportService } from '@app/core/services/import.service';
import { ColumnDefinitionModel } from '@app/shared/models/column-definition.model';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import { TableActionIcon, TableIndication, TableRowAction } from '@app/shared/models/table-action-type.model';
import { ImportDetailModalComponent } from '@app/features/administration/import-logs/import-detail-modal/import-detail-modal.component';
import { FileDownloadService } from '@app/core/services/filedownload.service';
import { ModalComponent } from '@app/shared/components/modal/modal.component';

@Component({
    selector: 'app-import-logs-detail',
    templateUrl: './import-logs-detail.component.html',
    styleUrls: ['./import-logs-detail.component.scss']
})
export class ImportLogsDetailComponent implements OnInit, OnDestroy {

    unsubscribe$: Subject<boolean> = new Subject<boolean>();
    import: ImportModel;
    details: ImportDetailModel[] = [];
    tableIndications: TableIndication[] = [];
    tableActions: TableRowAction[] = [];
    configKey: string;
    exportFileName: string;
    columnsDefinition: ColumnDefinitionModel[] = [];

    constructor(private route: ActivatedRoute,
        private importService: ImportService,
        private router: Router,
        private fileDownloadService: FileDownloadService,
        public dialog: MatDialog) {
    }

    ngOnInit(): void {
        this.route.data.subscribe((data: any) => {
            this.import = data.import;
            this.details = data.details;
            this.configKey = data.configKey;
            this.exportFileName = data.exportFileName;
        });

        this.columnsDefinition = new TableColumnsConfigHelper().getColumnsDefinition(TableColumnsConfigKey.IMPORTHISTORYDETAIL);
        this.restoreFilters();
        this.initTableActions();
        this.initTableIndications();
    }

    restoreFilters() {

    }

    initTableActions() {
        this.tableActions.push(new TableRowAction(TableActionIcon.ZOOM, "Voir le détail", this.onZoom));
        this.tableActions.push(new TableRowAction(TableActionIcon.DOWNLOAD, "Télécharger le JSON", this.onJson, (data: ImportDetailModel) => !_.isNil(data.JsonContent)));
        this.tableActions.push(new TableRowAction(TableActionIcon.PDF, "Télécharger le PDF", this.onPdf, (data: ImportDetailModel) => data.HasPdfContent));
    }

    initTableIndications() {
        const isOk = (importRow: ImportDetailModel) => importRow.IsValid && _.isNil(importRow.RecoveryDate);
        const isRecovered = (importRow: ImportDetailModel) => importRow.IsValid && !_.isNil(importRow.RecoveryDate);
        const needsRecovery = (importRow: ImportDetailModel) => !importRow.IsValid && importRow.HasPdfContent;
        const isKO = (importRow: ImportDetailModel) => !importRow.IsValid && !importRow.HasPdfContent && _.isNil(importRow.OcrMetadataId);
        const isInjected = (importRow: ImportDetailModel) => !importRow.IsValid && !_.isNil(importRow.OcrMetadataId);
        this.tableIndications.push(new TableIndication(TableActionIcon.ADJUST, "Aucune erreur", isOk, 'indic-green'));
        this.tableIndications.push(new TableIndication(TableActionIcon.ADJUST, "A été récupéré", isRecovered, 'indic-blue'));
        this.tableIndications.push(new TableIndication(TableActionIcon.ADJUST, "Va être récupérer", needsRecovery, 'indic-orange'));
        this.tableIndications.push(new TableIndication(TableActionIcon.ADJUST, "Erreur", isKO, 'indic-red'));
        this.tableIndications.push(new TableIndication(TableActionIcon.ADJUST, "Réinjectée", isInjected, 'indic-pink'));
    }

    onSubmit(): void {
        this.importService.getImportDetails(this.import.Id)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((details: ImportDetailModel[]) => {
                this.details = details;
            })
    }

    onZoom = (detail: ImportDetailModel) => {
        const workflowStageValidationConfig = new ModalHelper().getImportDetailConfig(this.import, detail)
        const dialog = this.dialog.open(ImportDetailModalComponent, workflowStageValidationConfig);

        return dialog.afterClosed();
    }

    onJson = (detail: ImportDetailModel) => {
        const jsonContent = new Blob([detail.JsonContent], {
            type: 'application/json',
        });
        this.fileDownloadService.downloadBlob(jsonContent, detail.JsonFileName, "application/json");
    }

    onPdf = (detail: ImportDetailModel) => {
        this.importService.getImportDetailPdfContent(this.import.Id, detail.Id)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((blobData: Blob) => {
                this.fileDownloadService.downloadBlob(blobData, detail.PdfFileName, "application/pdf");
            }, (_) => {
                const modalErreurConfig = new ModalHelper().getAlertConfig(`Une erreur est survenue lors du téléchargement.`);
                this.dialog.open(ModalComponent, modalErreurConfig);
            });
    }

    onBack(): void {
        this.router.navigate(['/administration/import-logs']);
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
    }
}